'use strict';

// Keep in sync with zine.py

var DEFAULT_COVERS = [1, 2, 3, 4, 5].map(i =>
  '//stampsy-eu-1.s3.amazonaws.com/2014/10/13/patters/' + i + '.svg'
);

function getZineCover(zine) {
  if (zine.coverUrl) {
    return {
      isDefault: false,
      url: zine.coverUrl
    };
  }

  return {
    isDefault: true,
    url: DEFAULT_COVERS[zine.id % DEFAULT_COVERS.length || 0]
  };
}

module.exports = getZineCover;


/** WEBPACK FOOTER **
 ** ./utils/getZineCover.js
 **/